import User from "../entities/User";

export default class {
    createUser(authUser) {
        let user = new User({
            nombres: authUser.nombres, 
            rut: authUser.id,
            apellidos: authUser.apellidos,
            email: authUser.email, 
            idToken: authUser.jwtToken,
            userType: authUser.tipousuario, 
            permisos: authUser.permisos        
        });
        return user;
    };
};